import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import "./Media.css";
import { Post } from "../../interfaces/interfaces";
import { posts } from "../../constants";

const Media: React.FC = () => {
  // Dynamic Header Blur Effect
  useEffect(() => {
    const header = document.querySelector(".header-container") as HTMLElement;
    if (header) {
      header.style.backdropFilter = `blur(20px)`; // Max blur of 10px
    }
  }, []);

  const [selectedPost, setSelectedPost] = useState<Post | null>(null);

  // Sort Media by date (newest first)
  const sortedMedia = [...posts].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  return (
    <div className="media-container">
      <Helmet>
        <title>Media | Zied Zouari</title>
        <meta name="keywords" content="Zied Zouari, music, albums, collaborations, violinist, composer" />
      </Helmet>
      <main className="media-main">
        <div className="blog-header">
          <h1>Médias</h1>
        </div>
        {/* List of Media */}
        <div className="post-list">
          {sortedMedia.map((post) => (
            <div
              key={post.id}
              className="post-item"
              onClick={() => setSelectedPost(post)}
            >
              <img src={post.imageUrl} alt={post.title} />
              <div className="item-content">
                <span className="post-date">{post.date}</span>
                <h2>{post.title}</h2>
              </div>
            </div>
          ))}
        </div>

        {/* Modal for displaying the full excerpt */}
        {selectedPost && (
          <div className="modal-overlay" onClick={() => setSelectedPost(null)}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button
                className="close-modal"
                onClick={() => setSelectedPost(null)}
              >
                ×
              </button>
              <img src={selectedPost.imageUrl} alt={selectedPost.title} />
              <h2>{selectedPost.title}</h2>
              <p>{selectedPost.excerpt}</p>
              <button
                className="category-tag"
                onClick={() => window.open(selectedPost.link, "_blank")}
              >
                Lire Plus sur {selectedPost.category}
              </button>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default Media;